/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Status_Pattern_ExcludedInputs */



/**
* | output |
* | --- |
* | "Excluded by filter pattern" |
*
* @param {Spaces_Status_Pattern_ExcludedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_status_pattern_excluded = /** @type {((inputs?: Spaces_Status_Pattern_ExcludedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Status_Pattern_ExcludedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Durch Filtermuster ausgeschlossen")
	return /** @type {LocalizedString} */ ("Excluded by filter pattern")
});